import { useMe } from './useMe'

const initialLocation = {
  latitude: 0,
  longitude: 0,
  name: '',
  placeId: '',
}

export const useDefaultLocation = () => {
  const me = useMe()
  return me?.company?.dashboardLocation || initialLocation
}
